import { createSlice } from '@reduxjs/toolkit';

const integrationCategorySlice = createSlice({
  name: 'integrationCategory',
  initialState: {
    list: [],
    reload: 0,
    changeCount: 0,
    idDeleted: false,
  },
  reducers: {
    getCategoryListFromDB: () => {},
    getCategoryListFromDBSuccess: (state, { payload }) => {
      state.list = payload;
    },
    removeCategory: state => {
      state.idDeleted = false;
    },
    removeCategorySuccess: state => {
      state.idDeleted = true;
      state.reload += 1;
      state.changeCount += 1;
    },
    changeCount: () => {},
    changeCountSuccess: state => {
      state.changeCount += 1;
    },
    changeOrderCategories: () => {},
    changeOrderCategoriesSuccess: state => {
      state.reload += 1;
      state.changeCount += 1;
    },
  },
});

export const {
  getCategoryListFromDB,
  getCategoryListFromDBSuccess,
  removeCategory,
  removeCategorySuccess,
  changeCount,
  changeCountSuccess,
  changeOrderCategories,
  changeOrderCategoriesSuccess,
} = integrationCategorySlice.actions;
export default integrationCategorySlice.reducer;
